import { Box } from '@/components/Box/Box';
import { Typography } from '@/components/Typography/Typography';
import { ButtonNew } from '@/components-new/ButtonNew/ButtonNew';
import { COLORS } from '@/styles/colors';
import { SetupBanner } from '../styles';

export const SetupVaultBanner = ({ onSetup }: { onSetup: () => void }) => (
  <SetupBanner>
    <Box display='flex' flexDirection='column' gap='8px' maxWidth='640px'>
      <Typography variant='caption' fontWeight='semibold' color={COLORS.green[350]}>
        STEP 1
      </Typography>
      <Typography variant='headline4' color={COLORS.white}>
        Set up My Vault
      </Typography>
      <Typography variant='bodySmall' color={COLORS.grey[300]}>
        Store the banking instructions you use to receive ACH, wire and international wire payments. You share them
        through a secure link, and only verified people can open it.
      </Typography>
    </Box>
    <ButtonNew size='large' onClick={onSetup}>
      Set up My Vault
    </ButtonNew>
  </SetupBanner>
);
